module.exports = __webpack_public_path__ + "img/coffee.06450959.jpg";